<div class="d-flex align-items-center justify-content-between flex-wrap">
  <h1>
    {{ 'account.punchout.heading' | translate }}
  </h1>
  <a *ngIf="selectedType === 'oci'" routerLink="configuration" class="btn btn-secondary m-0">{{
    'account.punchout.configuration.button.label' | translate
  }}</a>
</div>
<ish-error-message [error]="error" />

<p *ngIf="punchoutTypes?.length > 0; else noPunchoutTypes">
  {{ 'account.punchout.subtitle' | translate }}
</p>
<ng-template #noPunchoutTypes>
  <ish-info-message message="account.punchout.no.protocols.info" [toast]="false" />
</ng-template>

<div *ngIf="punchoutTypes?.length > 1">
  <ul ngbNav class="nav-tabs section" [(activeId)]="selectedType">
    <li *ngFor="let type of punchoutTypes" [ngbNavItem]="type" role="presentation">
      <a ngbNavLink [routerLink]="['../punchout']" [queryParams]="{ format: type }" class="mb-0">{{
        'account.punchout.type.text' | translate : { '0': type }
      }}</a>
    </li>
  </ul>
</div>
